import React from 'react';
import { Button } from './ui/Button';
const CHECKOUT_URL = 'https://www.tubienestarinterno.com/cart/53266912084305:1';
export function FinalCTASection() {
  const goToCheckout = () => {
    window.location.href = CHECKOUT_URL;
  };
  return <section className="py-10 px-4 bg-white relative overflow-hidden" data-id="element-59">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[800px] bg-warm-accent/5 rounded-full blur-3xl -z-10" data-id="element-60"></div>

      <div className="max-w-4xl mx-auto" data-id="element-61">
        {/* Emotional Closing Image */}
        <div className="rounded-3xl overflow-hidden mb-8 shadow-lg max-w-2xl mx-auto" data-id="element-62">
          <img src="https://cdn.magicpatterns.com/uploads/h2XaGx1T2HgR62iWHrLdyZ/imagen_3.png" alt="Madre e hijo abrazados con luz cálida de atardecer - la paz que mereces" className="w-full h-auto object-cover" data-id="element-63" />
        </div>

        <div className="text-center" data-id="element-64">
          <h2 className="text-4xl md:text-6xl font-bold text-deep-blue mb-6 tracking-tight" data-id="element-65">
            Mañana a esta hora <br className="hidden md:block" data-id="element-66" />
            <span className="text-warm-accent" data-id="element-67">
              tu tarde puede ser distinta.
            </span>
          </h2>

          <div className="flex flex-col items-center gap-5" data-id="element-68">
            <Button onClick={goToCheckout} className="animate-pulse-soft text-xl py-5 px-10 w-full md:w-auto" data-id="element-69">
              SÍ, QUIERO EL PROTOCOLO CERO GRITOS
            </Button>

            <p className="text-lg text-deep-blue/80 font-medium" data-id="element-70">
              ⭐⭐⭐⭐⭐ 4.9/5 basado en 4,500+ opiniones.
            </p>

            {/* Payment Badges (Text-based) */}
            <div className="flex flex-wrap justify-center gap-3 mt-4" data-id="element-71">
              {['Apple Pay', 'Google Pay', 'PayPal', 'Visa', 'Mastercard'].map(method => <div key={method} className="px-4 py-2 bg-cream border border-gray-200 rounded-md text-sm font-bold text-deep-blue/60 shadow-sm" data-id="element-72">
                    {method}
                  </div>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}